import "./checkboxCustom.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";

export default class CheckboxCustom extends Component {
  static propTypes = {
    id: PropTypes.string
  };

  isChecked = checked => {
    switch (checked) {
      case true:
      case "true":
      case 1:
        return true;
      default:
        return false;
    }
  };

  onClick = ({ target: { checked } }) => {
    const { actions, feature, uid, field, onClick } = this.props;
    if (onClick) {
      onClick(uid, checked);
    } else {
      actions.setEntityField(feature, uid, field, checked.toString());
    }
  };

  render() {
    const { id, checked, disabled, checkedText, notCheckedText } = this.props;
    return (
      <div className="row">
        <div className="col-xs-3">
          <div className="onoffswitch">
            <input
              name={id}
              id={id}
              type="checkbox"
              checked={this.isChecked(checked)}
              onClick={this.onClick}
              disabled={disabled}
              name="onoffswitch"
              className="onoffswitch-checkbox"
            />
            <label className="onoffswitch-label" htmlFor={id} />
          </div>
        </div>
        <div className="col-xs-9 label">
          {this.isChecked(checked) ? checkedText ? (
            checkedText
          ) : (
            "Pole jest aktywne"
          ) : notCheckedText ? (
            notCheckedText
          ) : (
            "Pole jest nieaktywne"
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/checkboxCustom.react.js